module.exports = __webpack_public_path__ + "img/usuario.23d13a1d.png";